import React from 'react'

const BigBanner = ({ content }) => {
  return (
    <div className='
          layout-spacing 
          bg-banner bg-cover bg-center bg-no-repeat h-[calc(100svh-6rem)] 
    '>
      <div className='layout-width text-base-100'>
        {content}
      </div>
    </div>
  )
}

export default BigBanner